import "../../styles/UserDashboard/EnergyListing.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import EnergyHeader from "../../components/energy/energyHeader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { getEnergyListed } from "../../apis/energySharing";
import { useSelector } from "react-redux";
import MyListings from "../../components/energy/MyListings";
import Web3 from "web3";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";

export default function EnergyListing() {
  const auth = useSelector((state) => state.auth);
  const [tab, setTab] = useState("buy");
  const [sellerListings, setSellerListings] = useState([]);
  const [buyerListings, setBuyerListings] = useState([]);
  const [myListings, setMyListings] = useState([]);
  const [account, setAccount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const [itemsPerPage] = useState(10);
  const [buyTotalItems, setBuyTotalItems] = useState(0);
  const [sellTotalItems, setSellTotalItems] = useState(0);
  const [buyCurrentPage, setBuyCurrentPage] = useState(1);
  const [sellCurrentPage, setSellCurrentPage] = useState(1);
  const [myListingsCurrentPage, setMyListingsCurrentPage] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          alert(
            "Please allow access to your MetaMask wallet to enable you exchange your CCRT"
          );
          console.error("User denied account access", err);
        });
    } else {
      console.error(
        "MetaMask is not installed. Please install it to use this app."
      );
    }
  }, []);

  const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";
  const contractABI = EnergySharingContract.abi;

  useEffect(() => {
    if (web3) {
      const contractInstance = new web3.eth.Contract(contractABI, contractAddress);
      setContract(contractInstance);
    }
  }, [web3]);

  // Get all active seller listings (for BUY tab)
  const handleGetActiveSellerListings = async (page = 1) => {
    try {
      console.log(`Fetching active seller listings for BUY tab, page ${page}...`);
      const offset = (page - 1) * itemsPerPage;
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();
      const { listings, totalCount } = await integration.getActiveListings(offset, itemsPerPage);
      setSellerListings(listings?.reverse() || []);
      setBuyTotalItems(Number(totalCount));
      setBuyCurrentPage(page);
    } catch (error) {
      console.error("Failed to fetch active seller listings:", error);
    }
  };

  // Get all buyer demands (for SELL tab)
  const handleGetBuyerDemands = async (page = 1) => {
    try {
      console.log(`Fetching buyer demands for SELL tab, page ${page}...`);
      const offset = (page - 1) * itemsPerPage;
      const buyerIntegration = new EnergyTradingIntegration("buyer");
      await buyerIntegration.init();
      const { demands, totalCount } = await buyerIntegration.getActiveDemands(offset, itemsPerPage);

      // Map blockchain demands
      const blockchainDemands = demands?.map((demand) => ({
        id: demand.demandId,
        energyType: demand.energyType,
        quantity: demand.quantity,
        pricePerUnit: demand.pricePerUnit,
        location: demand.location,
        minSellAmount: demand.minSellAmount,
        maxSellAmount: demand.maxSellAmount,
        status: demand.status,
        buyer: demand.buyer,
        userId: demand.userId,
        isBlockchain: true
      })) || [];

      // Get additional web2 data
      try {
        const response2 = await getEnergyListed("buy", auth?.token);
        if (response2?.data?.statusCode === 200) {
          const web2Demands = response2?.data?.data?.items || [];
          const combinedDemands = [...blockchainDemands, ...web2Demands];
          setBuyerListings(combinedDemands);
        } else {
          setBuyerListings(blockchainDemands);
        }
      } catch (web2Error) {
        console.error("Web2 buy data failed:", web2Error);
        setBuyerListings(blockchainDemands);
      }

      setSellTotalItems(Number(totalCount));
      setSellCurrentPage(page);
    } catch (error) {
      console.error("Failed to fetch buyer demands:", error);
    }
  };

  useEffect(() => {
    if (tab === "buy") {
      handleGetActiveSellerListings(buyCurrentPage);
    } else if (tab === "sell") {
      handleGetBuyerDemands(sellCurrentPage);
    }
  }, [tab, buyCurrentPage, sellCurrentPage]);

  // Initial load for buy tab
  useEffect(() => {
    handleGetActiveSellerListings();
  }, []);

  // Add Pagination component
  const Pagination = ({ currentPage, totalItems, onPageChange, itemsPerPage }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
      <div className="pagination">
        <button
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
          className="pagination-button"
        >
          Previous
        </button>

        <span className="pagination-info">
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="pagination-button"
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <div className="energyListing">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="energyListing__inner">
        <EnergyHeader />

        <div className="energyListing__inner__card">
          <div className="energyListing__inner__card__filter">
            <div className="energyListing__inner__card__filter__search">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.18016 12.2002C6.1873 12.2002 5.21673 11.9057 4.3912 11.3541C3.56566 10.8025 2.92224 10.0185 2.54228 9.10123C2.16233 8.18394 2.06292 7.17459 2.25662 6.20081C2.45031 5.22702 2.92842 4.33254 3.63048 3.63048C4.33254 2.92842 5.22702 2.45031 6.20081 2.25662C7.17459 2.06292 8.18394 2.16233 9.10123 2.54228C10.0185 2.92224 10.8025 3.56566 11.3541 4.3912C11.9057 5.21673 12.2002 6.1873 12.2002 7.18016C12.2002 7.83939 12.0703 8.49218 11.818 9.10123C11.5658 9.71028 11.196 10.2637 10.7298 10.7298C10.2637 11.196 9.71028 11.5658 9.10123 11.818C8.49218 12.0703 7.83939 12.2002 7.18016 12.2002ZM7.18016 3.16683C6.38903 3.16683 5.61567 3.40142 4.95788 3.84095C4.30008 4.28047 3.78739 4.90519 3.48464 5.63609C3.18189 6.367 3.10268 7.17126 3.25702 7.94719C3.41136 8.72311 3.79232 9.43584 4.35173 9.99525C4.91114 10.5547 5.62387 10.9356 6.3998 11.09C7.17572 11.2443 7.97999 11.1651 8.71089 10.8623C9.4418 10.5596 10.0665 10.0469 10.506 9.38911C10.9456 8.73131 11.1802 7.95795 11.1802 7.16683C11.1802 6.10596 10.7587 5.08854 10.0086 4.3384C9.25844 3.58825 8.24102 3.16683 7.18016 3.16683Z"
                  fill="#667185"
                />
                <path
                  d="M13.3327 13.8327C13.267 13.833 13.2019 13.8202 13.1412 13.795C13.0805 13.7698 13.0255 13.7327 12.9793 13.686L10.226 10.9327C10.1377 10.8379 10.0896 10.7125 10.0919 10.583C10.0942 10.4534 10.1466 10.3299 10.2382 10.2382C10.3299 10.1466 10.4534 10.0942 10.583 10.0919C10.7125 10.0896 10.8379 10.1377 10.9327 10.226L13.686 12.9793C13.7796 13.0731 13.8322 13.2002 13.8322 13.3327C13.8322 13.4652 13.7796 13.5922 13.686 13.686C13.6398 13.7327 13.5848 13.7698 13.5241 13.795C13.4634 13.8202 13.3984 13.833 13.3327 13.8327Z"
                  fill="#667185"
                />
              </svg>

              <input type="text" placeholder="Search by name" />
            </div>

            <div className="energyListing__inner__card__filter__filter">
              <svg
                width="36"
                height="32"
                viewBox="0 0 36 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="35"
                  height="31"
                  rx="3.5"
                  fill="white"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="35"
                  height="31"
                  rx="3.5"
                  stroke="#E5E5E5"
                />
                <path
                  d="M25.9321 17.0417C25.7433 18.4816 25.166 19.843 24.2622 20.9798C23.3585 22.1166 22.1623 22.986 20.802 23.4947C19.4418 24.0034 17.9687 24.1321 16.5407 23.8672C15.1128 23.6023 13.7839 22.9537 12.6966 21.991C11.6093 21.0282 10.8046 19.7876 10.3688 18.4023C9.93292 17.017 9.8824 15.5391 10.2226 14.1272C10.5629 12.7154 11.281 11.4228 12.3001 10.388C13.3191 9.35327 14.6006 8.61544 16.0071 8.25366C19.9061 7.25366 23.9421 9.26066 25.4321 13.0007"
                  stroke="#98A2B3"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 8V13H21"
                  stroke="#98A2B3"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <svg
                width="76"
                height="32"
                viewBox="0 0 76 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_5079_34594" fill="white">
                  <path d="M0 2C0 0.895431 0.895431 0 2 0H74C75.1046 0 76 0.895431 76 2V30C76 31.1046 75.1046 32 74 32H2C0.895432 32 0 31.1046 0 30V2Z" />
                </mask>
                <path
                  d="M0 2C0 0.895431 0.895431 0 2 0H74C75.1046 0 76 0.895431 76 2V30C76 31.1046 75.1046 32 74 32H2C0.895432 32 0 31.1046 0 30V2Z"
                  fill="white"
                />
                <path
                  d="M2 1H74V-1H2V1ZM75 2V30H77V2H75ZM74 31H2V33H74V31ZM1 30V2H-1V30H1ZM2 31C1.44772 31 1 30.5523 1 30H-1C-1 31.6569 0.343148 33 2 33V31ZM75 30C75 30.5523 74.5523 31 74 31V33C75.6569 33 77 31.6569 77 30H75ZM74 1C74.5523 1 75 1.44772 75 2H77C77 0.343145 75.6569 -1 74 -1V1ZM2 -1C0.343146 -1 -1 0.343146 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
                  fill="#E5E5E5"
                  mask="url(#path-1-inside-1_5079_34594)"
                />
                <path
                  d="M14.5568 20.5V11.7727H19.7898V12.7102H15.6136V15.6591H19.3977V16.5966H15.6136V20.5H14.5568ZM21.4634 20.5V13.9545H22.4691V20.5H21.4634ZM21.9748 12.8636C21.7788 12.8636 21.6097 12.7969 21.4677 12.6634C21.3285 12.5298 21.2589 12.3693 21.2589 12.1818C21.2589 11.9943 21.3285 11.8338 21.4677 11.7003C21.6097 11.5668 21.7788 11.5 21.9748 11.5C22.1708 11.5 22.3384 11.5668 22.4776 11.7003C22.6197 11.8338 22.6907 11.9943 22.6907 12.1818C22.6907 12.3693 22.6197 12.5298 22.4776 12.6634C22.3384 12.7969 22.1708 12.8636 21.9748 12.8636ZM25.3168 11.7727V20.5H24.3111V11.7727H25.3168ZM30.0053 13.9545V14.8068H26.6133V13.9545H30.0053ZM27.6019 12.3864H28.6076V18.625C28.6076 18.9091 28.6488 19.1222 28.7312 19.2642C28.8164 19.4034 29.055 19.5455C29.1886 19.5909 29.3292 19.6136 29.4769 19.6136C29.5877 19.6136 29.6786 19.608 29.7496 19.5966C29.8207 19.5824 29.8775 19.571 29.9201 19.5625L30.1246 20.4659C30.0565 20.4915 29.9613 20.517 29.8391 20.5426C29.717 20.571 29.5621 20.5852 29.3746 20.5852C29.0906 20.5852 28.8121 20.5241 28.5394 20.402C28.2695 20.2798 28.0451 20.0938 27.8661 19.8438C27.69 19.5938 27.6019 19.2784 27.6019 18.8977V12.3864ZM34.1921 20.6364C33.5614 20.6364 33.0174 20.4972 32.56 20.2188C32.1055 19.9375 31.7546 19.5455 31.5075 19.0426C31.2631 18.5369 31.141 17.9489 31.141 17.2784C31.141 16.608 31.2631 16.017 31.5075 15.5057C31.7546 14.9915 32.0984 14.5909 32.5387 14.304C32.9819 14.0142 33.4989 13.8693 34.0898 13.8693C34.4308 13.8693 34.7674 13.9261 35.0998 14.0398C35.4322 14.1534 35.7347 14.3381 36.0075 14.5938C36.2802 14.8466 36.4975 15.1818 36.6594 15.5994C36.8214 16.017 36.9023 16.5312 36.9023 17.142V17.5682H31.8569V16.6989H35.8796C35.8796 16.3295 35.8058 16 35.658 15.7102C35.5131 15.4205 35.3058 15.1918 35.0359 15.0241C34.7688 14.8565 34.4535 14.7727 34.0898 14.7727C33.6893 14.7727 33.3427 14.8722 33.0501 15.071C32.7603 15.267 32.5373 15.5227 32.381 15.8381C32.2248 16.1534 32.1467 16.4915 32.1467 16.8523V17.4318C32.1467 17.9261 32.2319 18.3452 32.4023 18.6889C32.5756 19.0298 32.8157 19.2898 33.1225 19.4688C33.4293 19.6449 33.7859 19.733 34.1921 19.733C34.4563 19.733 34.695 19.696 34.908 19.6222C35.1239 19.5455 35.31 19.4318 35.4663 19.2812C35.6225 19.1278 35.7433 18.9375 35.8285 18.7102L36.8001 18.983C36.6978 19.3125 36.5259 19.6023 36.2844 19.8523C36.043 20.0994 35.7447 20.2926 35.3896 20.4318C35.0344 20.5682 34.6353 20.6364 34.1921 20.6364ZM38.4322 20.5V13.9545H39.4038V14.9432H39.4719C39.5913 14.6193 39.8072 14.3565 40.1197 14.1548C40.4322 13.9531 40.7844 13.8523 41.1765 13.8523C41.2504 13.8523 41.3427 13.8537 41.4535 13.8565C41.5643 13.8594 41.6481 13.8636 41.7049 13.8693V14.892C41.6708 14.8835 41.5927 14.8707 41.4705 14.8537C41.3512 14.8338 41.2248 14.8239 41.0913 14.8239C40.7731 14.8239 40.489 14.8906 40.239 15.0241C39.9918 15.1548 39.7958 15.3366 39.6509 15.5696C39.5089 15.7997 39.4379 16.0625 39.4379 16.358V20.5H38.4322Z"
                  fill="#101828"
                />
                <path
                  d="M58.4998 10.666H50.4998C49.7631 10.666 49.1491 11.2727 49.3311 11.986C49.525 12.7419 49.8819 13.4462 50.3769 14.0495C50.8719 14.6527 51.493 15.1403 52.1965 15.478C52.7451 15.7407 53.1665 16.2567 53.1665 16.8647V20.9207C53.1665 21.0343 53.1956 21.146 53.251 21.2452C53.3063 21.3444 53.3861 21.4278 53.4827 21.4875C53.5794 21.5472 53.6897 21.5812 53.8031 21.5863C53.9166 21.5914 54.0295 21.5675 54.1311 21.5167L55.4645 20.85C55.5752 20.7947 55.6683 20.7096 55.7334 20.6044C55.7985 20.4991 55.8331 20.3778 55.8331 20.254V16.8647C55.8331 16.2567 56.2545 15.7407 56.8025 15.478C57.5062 15.1405 58.1275 14.6529 58.6228 14.0497C59.118 13.4464 59.4751 12.742 59.6691 11.986C59.8498 11.2727 59.2351 10.666 58.4998 10.666Z"
                  stroke="#98A2B3"
                  stroke-width="1.33333"
                />
              </svg>
            </div>
          </div>
          <div className="energyListing__inner__tabs">
            <div
              className={tab === "buy" && "energyListing__inner__tabs__active"}
              onClick={() => setTab("buy")}
            >
              Buy
            </div>
            <div
              className={tab === "sell" && "energyListing__inner__tabs__active"}
              onClick={() => setTab("sell")}
            >
              Sell
            </div>
            <div
              className={
                tab === "my-listings" && "energyListing__inner__tabs__active"
              }
              onClick={() => setTab("my-listings")}
            >
              My listings
            </div>
          </div>

          {tab === "buy" && (
            <>
              {sellerListings?.map((listing) => (
                <div key={listing?.listingId} className="energyListing__inner__card__item">
                  <div className="energyListing__inner__card__item__user">
                    <div className="energyListing__inner__card__item__user__img">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                          stroke="#2C9963"
                          stroke-width="2"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                          stroke="#2C9963"
                          stroke-width="2"
                        />
                      </svg>
                    </div>

                    <div className="energyListing__inner__card__item__user__info">
                      <div className="energyListing__inner__card__item__user__info__title">
                        {listing?.location}
                      </div>
                      <div className="energyListing__inner__card__item__user__info__location">
                        Location: <span>{listing?.location}</span>
                      </div>
                      <div className="energyListing__inner__card__item__user__info__time">
                        <div>
                          Listed: <span>12 mins ago</span>
                        </div>
                        <div>
                          Completed: <span>0</span>
                        </div>
                      </div>

                      <div className="energyListing__inner__card__item__user__info__payment">
                        <svg
                          width="8"
                          height="8"
                          viewBox="0 0 8 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.7513 6.125H1.2513C1.06721 6.125 0.917969 6.27424 0.917969 6.45833V6.79167C0.917969 6.97576 1.06721 7.125 1.2513 7.125H6.7513C6.9354 7.125 7.08464 6.97576 7.08464 6.79167V6.45833C7.08464 6.27424 6.9354 6.125 6.7513 6.125Z"
                            stroke="#667185"
                            stroke-width="0.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1.7513 3.2919V6.12857M6.2513 3.2919V6.12857M4.83464 3.2919V6.12857M3.16797 3.2919V6.12857M3.6813 1.05057L1.0913 2.46724C1.03885 2.49594 0.995077 2.53822 0.964581 2.58965C0.934085 2.64109 0.917985 2.69978 0.917969 2.75957V3.0919C0.917969 3.14495 0.93904 3.19582 0.976547 3.23333C1.01405 3.27083 1.06493 3.2919 1.11797 3.2919H6.88464C6.93768 3.2919 6.98855 3.27083 7.02606 3.23333C7.06356 3.19582 7.08464 3.14495 7.08464 3.0919V2.75957C7.08462 2.69978 7.06852 2.64109 7.03802 2.58965C7.00753 2.53822 6.96376 2.49594 6.9113 2.46724L4.3213 1.05057C4.22319 0.996887 4.11314 0.96875 4.0013 0.96875C3.88946 0.96875 3.77942 0.996887 3.6813 1.05057Z"
                            stroke="#667185"
                            stroke-width="0.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Paystack
                      </div>
                    </div>
                  </div>

                  <div className="energyListing__inner__card__item__info">
                    ₦{listing?.pricePerUnit} / kWh
                  </div>
                  <div className="energyListing__inner__card__item__available">
                    <div>
                      Amount: <span>{listing?.quantity} kWh</span>
                    </div>
                    <div>
                      Limit:{" "}
                      <span>
                        {listing?.minPurchaseAmount} -{" "}
                        {listing?.maxPurchaseAmount} kWh
                      </span>
                    </div>
                    <div>
                      Est Time: <span>30mins</span>
                    </div>
                  </div>

                  <button
                    onClick={() =>
                      navigate(`/buy-energy/${listing?.listingId}`)
                    }
                  >
                    Buy
                  </button>
                </div>
              ))}

              {/* Buy Tab Pagination */}
              <Pagination
                currentPage={buyCurrentPage}
                totalItems={buyTotalItems}
                onPageChange={setBuyCurrentPage}
                itemsPerPage={itemsPerPage}
              />
            </>
          )}

          {tab === "sell" && (
            <>
              {buyerListings?.map((listing) => (
                <div key={listing?.id} className="energyListing__inner__card__item">
                  <div className="energyListing__inner__card__item__user">
                    <div className="energyListing__inner__card__item__user__img">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                          stroke="#2C9963"
                          stroke-width="2"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                          stroke="#2C9963"
                          stroke-width="2"
                        />
                      </svg>
                    </div>

                    <div className="energyListing__inner__card__item__user__info">
                      <div className="energyListing__inner__card__item__user__info__title">
                        House {listing?.houseNumber}
                      </div>
                      <div className="energyListing__inner__card__item__user__info__location">
                        Location:{" "}
                        <span>
                          {listing?.address}, {listing?.state}
                        </span>
                      </div>
                      <div className="energyListing__inner__card__item__user__info__time">
                        <div>
                          Listed: <span>12 mins ago</span>
                        </div>
                        <div>
                          Completed: <span>0</span>
                        </div>
                      </div>

                      <div className="energyListing__inner__card__item__user__info__payment">
                        <svg
                          width="8"
                          height="8"
                          viewBox="0 0 8 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.7513 6.125H1.2513C1.06721 6.125 0.917969 6.27424 0.917969 6.45833V6.79167C0.917969 6.97576 1.06721 7.125 1.2513 7.125H6.7513C6.9354 7.125 7.08464 6.97576 7.08464 6.79167V6.45833C7.08464 6.27424 6.9354 6.125 6.7513 6.125Z"
                            stroke="#667185"
                            stroke-width="0.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1.7513 3.2919V6.12857M6.2513 3.2919V6.12857M4.83464 3.2919V6.12857M3.16797 3.2919V6.12857M3.6813 1.05057L1.0913 2.46724C1.03885 2.49594 0.995077 2.53822 0.964581 2.58965C0.934085 2.64109 0.917985 2.69978 0.917969 2.75957V3.0919C0.917969 3.14495 0.93904 3.19582 0.976547 3.23333C1.01405 3.27083 1.06493 3.2919 1.11797 3.2919H6.88464C6.93768 3.2919 6.98855 3.27083 7.02606 3.23333C7.06356 3.19582 7.08464 3.14495 7.08464 3.0919V2.75957C7.08462 2.69978 7.06852 2.64109 7.03802 2.58965C7.00753 2.53822 6.96376 2.49594 6.9113 2.46724L4.3213 1.05057C4.22319 0.996887 4.11314 0.96875 4.0013 0.96875C3.88946 0.96875 3.77942 0.996887 3.6813 1.05057Z"
                            stroke="#667185"
                            stroke-width="0.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Paystack
                      </div>
                    </div>
                  </div>

                  <div className="energyListing__inner__card__item__info">
                    ₦{listing?.rate} / kWh
                  </div>
                  <div className="energyListing__inner__card__item__available">
                    <div>
                      Amount: <span>{listing?.amount} kWh</span>
                    </div>
                    <div>
                      Limit:{" "}
                      <span>
                        {listing?.energyLimit?.min} -{" "}
                        {listing?.energyLimit?.max} kWh
                      </span>
                    </div>
                    <div>
                      Est Time: <span>30mins</span>
                    </div>
                  </div>

                  <button
                    onClick={() => navigate(`/sell-energy/${listing?.id}`)}
                  >
                    Sell
                  </button>
                </div>
              ))}

              {/* Sell Tab Pagination */}
              <Pagination
                currentPage={sellCurrentPage}
                totalItems={sellTotalItems}
                onPageChange={setSellCurrentPage}
                itemsPerPage={itemsPerPage}
              />
            </>
          )}

          {tab === "my-listings" && (
            <MyListings
              itemsPerPage={itemsPerPage}
              currentPage={myListingsCurrentPage}
              setCurrentPage={setMyListingsCurrentPage}
            />
          )}
        </div>
      </div>
    </div>
  );
}